import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import PropTypes from "prop-types";
import { FrameImpl } from "./frame.styles.es.js";
const propTypes = {
  as: PropTypes.elementType,
  border: PropTypes.bool,
  borderBottom: PropTypes.bool,
  borderLeft: PropTypes.bool,
  borderRight: PropTypes.bool,
  borderTop: PropTypes.bool,
  children: PropTypes.node.isRequired,
  role: PropTypes.string,
  sizing: PropTypes.oneOf(["fill-container", "fit-content"])
};
const defaultProps = {
  as: void 0,
  border: false,
  borderBottom: void 0,
  borderLeft: void 0,
  borderRight: void 0,
  borderTop: void 0,
  role: void 0,
  sizing: "fill-container"
};
const Frame = forwardRef(
  ({
    as,
    border,
    borderBottom,
    borderLeft,
    borderRight,
    borderTop,
    children,
    sizing,
    role
  }, ref) => /* @__PURE__ */ jsx(
    FrameImpl,
    {
      ref,
      as,
      role,
      $borderBottom: borderBottom ?? border,
      $borderLeft: borderLeft ?? border,
      $borderRight: borderRight ?? border,
      $borderTop: borderTop ?? border,
      $sizing: sizing,
      children
    }
  )
);
Frame.propTypes = propTypes;
Frame.defaultProps = defaultProps;
export {
  Frame
};
